export function getContentHash(url: string, uidx: string) {
    return uidx + '/' + url;
}
